import { breakdownChildResponse } from '@functions/amplience-functions';
import getComponents from '@functions/component-functions';

const GeneralNestedSlot = ({ body }) => {
  const res = breakdownChildResponse(body);
  return res ? res.map((cmpt) => getComponents(cmpt)) : null;
};

export default GeneralNestedSlot;
